var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.209 18.962c3.96 0 7.46-.856 9.612-2.167 2.577.98 4.178 2.35 4.178 3.86 0 2.997-6.267 5.424-14 5.424S2 23.845 2 20.852c0-1.562 1.706-2.97 4.439-3.962 2.132 1.37 5.71 2.072 9.769 2.072zm-.127-6.51c2.756 0 5.212-.547 6.852-1.403 2.302.754 3.762 1.876 3.762 3.133.004 2.268-4.75 4.106-10.615 4.106-5.862 0-10.614-1.839-10.614-4.107 0-1.257 1.465-2.383 3.762-3.132 1.64.855 4.096 1.402 6.853 1.402zM7.837 8.385C7.837 6.519 11.512 5 16.044 5c4.53 0 8.206 1.52 8.206 3.385 0 1.867-3.676 3.384-8.206 3.384s-8.207-1.518-8.207-3.385z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBal);
export default __webpack_public_path__ + "static/media/BAL.10565e3f5d49ebb47204faba26c9480a.svg";
export { ForwardRef as ReactComponent };